import { atom } from "recoil";
import { CanvasListDto } from "../services";

export const SelectedCanvasState = atom<CanvasListDto | null>({
  key: "selectedCanvasState ",
  default: null,
});
